export default __webpack_public_path__ + "static/media/Ipfs-icon.2c899a97.png";